/* eslint-disable */
// This is auto generated code, do not edit directly
// @ts-ignore
import * as Types from '../../../core/graphql/generated/types';

import { gql } from '@apollo/client';
import { HcoFragmentDoc } from '../../../core/fragments/Hco/HCO.hook';
import { NotFoundErrorFragmentDoc } from '../../../core/fragments/core.hook';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetHcoByIdQueryVariables = Types.Exact<{
	vid: Types.Scalars['ID']['input'];
	affiliationsPageSize: Types.Scalars['Int']['input'];
	includeInactiveAffiliation?: Types.Scalars['Boolean']['input'];
	includeDcrPartners?: Types.Scalars['Boolean']['input'];
}>;

export type GetHcoByIdQuery = {
	__typename?: 'Query';
	hco:
		| {
				__typename?: 'HCO';
				countryId?: string | null;
				businessType_V?: string | null;
				nhidCda_V?: string | null;
				hcoTaxId_V?: string | null;
				officePhoneCda_V?: string | null;
				faxCda_V?: string | null;
				emailCda_V?: string | null;
				websiteCda_V?: string | null;
				vaDodAffiliated_V?: boolean | null;
				vid_V: string;
				veevaid_V: string;
				statusCda_V?: string | null;
				statusCda_VId?: string | null;
				hcoNameCda_V?: string | null;
				hcoNameShort_V?: string | null;
				hcoNameEnglish_V?: string | null;
				hcoNameIntl_V?: string | null;
				hcoTypeCda_V?: string | null;
				localHcoType?: {
					__typename?: 'LocalHCOType';
					code: string;
					name: string;
					localizedName?: string | null;
				} | null;
				hcoHierarchyType?: {
					__typename?: 'HCOHierarchyType';
					code: string;
					name: string;
					localizedName?: string | null;
				} | null;
				hcpCount?: {
					__typename?: 'CountRange';
					code: string;
					name: string;
					localizedName?: string | null;
				} | null;
				prescriberCount?: {
					__typename?: 'CountRange';
					code: string;
					name: string;
					localizedName?: string | null;
				} | null;
				ownership?: {
					__typename?: 'HCOOwnership';
					code: string;
					name: string;
					localizedName?: string | null;
				} | null;
				academicStatus?: {
					__typename?: 'AcademicStatus';
					code: string;
					name: string;
					localizedName?: string | null;
				} | null;
				primaryLocalSpecialty?: {
					__typename?: 'LocalSpecialty';
					code: string;
					name: string;
					localizedName?: string | null;
				} | null;
				secondaryLocalSpecialty?: {
					__typename?: 'LocalSpecialty';
					code: string;
					name: string;
					localizedName?: string | null;
				} | null;
				localSpecialties: Array<{
					__typename?: 'LocalSpecialty';
					code: string;
					name: string;
					localizedName?: string | null;
				}>;
				mainOrganization?:
					| {
							__typename?: 'HCO';
							vid_V: string;
							veevaid_V: string;
							statusCda_V?: string | null;
							statusCda_VId?: string | null;
							hcoNameCda_V?: string | null;
							hcoNameShort_V?: string | null;
							hcoNameEnglish_V?: string | null;
							hcoNameIntl_V?: string | null;
							hcoTypeCda_V?: string | null;
							addresses: Array<{
								__typename?: 'Address';
								vid_V: string;
								primaryCda_V?: boolean | null;
								cityCda_V?: string | null;
								cityIntl_V?: string | null;
								stateCda_V?: string | null;
								countryCda_V?: string | null;
								streetAddress1Cda_V?: string | null;
								streetAddress1Intl_V?: string | null;
								postalCodeCda_V?: string | null;
								postalCodeIntl_V?: string | null;
							}>;
							hcoType?: {
								__typename?: 'HCOType';
								id: string;
								name: string;
							} | null;
					  }
					| { __typename?: 'ResourceNotFound'; message: string }
					| null;
				topOrganization?:
					| {
							__typename?: 'HCO';
							vid_V: string;
							veevaid_V: string;
							statusCda_V?: string | null;
							statusCda_VId?: string | null;
							hcoNameCda_V?: string | null;
							hcoNameShort_V?: string | null;
							hcoNameEnglish_V?: string | null;
							hcoNameIntl_V?: string | null;
							hcoTypeCda_V?: string | null;
							addresses: Array<{
								__typename?: 'Address';
								vid_V: string;
								primaryCda_V?: boolean | null;
								cityCda_V?: string | null;
								cityIntl_V?: string | null;
								stateCda_V?: string | null;
								countryCda_V?: string | null;
								streetAddress1Cda_V?: string | null;
								streetAddress1Intl_V?: string | null;
								postalCodeCda_V?: string | null;
								postalCodeIntl_V?: string | null;
							}>;
							hcoType?: {
								__typename?: 'HCOType';
								id: string;
								name: string;
							} | null;
					  }
					| { __typename?: 'ResourceNotFound'; message: string }
					| null;
				parentAffiliationSearch:
					| { __typename?: 'BadRequest' }
					| {
							__typename?: 'HCOAffiliationsResults';
							inactiveCount: number;
							paginationMetadata: {
								__typename?: 'PaginationMetadata';
								total: number;
								page: number;
								pageSize: number;
								totalPages: number;
							};
							results: Array<{
								__typename?: 'ParentHCO';
								vid_V: string;
								classOfWork_V?: string | null;
								isPrimaryRelationship_V?: boolean | null;
								parentHcoStatus_VId?: string | null;
								childVeevaid_V?: string | null;
								parentVeevaid_V?: string | null;
								jobTitle_V?: string | null;
								parentHco:
									| {
											__typename?: 'HCO';
											officePhoneCda_V?: string | null;
											vid_V: string;
											veevaid_V: string;
											statusCda_V?: string | null;
											statusCda_VId?: string | null;
											hcoNameCda_V?: string | null;
											hcoNameShort_V?: string | null;
											hcoNameEnglish_V?: string | null;
											hcoNameIntl_V?: string | null;
											hcoTypeCda_V?: string | null;
											addresses: Array<{
												__typename?: 'Address';
												streetAddress1Cda_V?: string | null;
												streetAddress1Intl_V?: string | null;
												streetAddress2Cda_V?: string | null;
												streetAddress2Intl_V?: string | null;
												postalCodeCda_V?: string | null;
												postalCodeIntl_V?: string | null;
												postalCodeFullUs_V?: string | null;
												cbsa_V?: string | null;
												latitudeCda_V?: number | null;
												longitudeCda_V?: number | null;
												statusCda_V?: string | null;
												statusCda_VId?: string | null;
												subStateAdminUnit_V?: string | null;
												businessCda_V?: boolean | null;
												dpvConfirmedIndicator_V?: string | null;
												buildingIdentifier_V?: string | null;
												phoneCda_V?: string | null;
												faxCda_V?: string | null;
												vid_V: string;
												primaryCda_V?: boolean | null;
												cityCda_V?: string | null;
												cityIntl_V?: string | null;
												stateCda_V?: string | null;
												countryCda_V?: string | null;
												hospitalCampus?:
													| {
															__typename?: 'HCO';
															vid_V: string;
															veevaid_V: string;
															statusCda_V?: string | null;
															statusCda_VId?: string | null;
															hcoNameCda_V?: string | null;
															hcoNameShort_V?: string | null;
															hcoNameEnglish_V?: string | null;
															hcoNameIntl_V?: string | null;
															hcoTypeCda_V?: string | null;
															addresses: Array<{
																__typename?: 'Address';
																vid_V: string;
																primaryCda_V?: boolean | null;
																cityCda_V?: string | null;
																cityIntl_V?: string | null;
																stateCda_V?: string | null;
																countryCda_V?: string | null;
																streetAddress1Cda_V?: string | null;
																streetAddress1Intl_V?: string | null;
																postalCodeCda_V?: string | null;
																postalCodeIntl_V?: string | null;
															}>;
															hcoType?: {
																__typename?: 'HCOType';
																id: string;
																name: string;
															} | null;
													  }
													| { __typename?: 'ResourceNotFound'; message: string }
													| null;
											}>;
											hcoType?: {
												__typename?: 'HCOType';
												id: string;
												name: string;
											} | null;
									  }
									| { __typename?: 'ResourceNotFound'; message: string };
								relationshipType?: {
									__typename?: 'RelationshipType';
									code: string;
									name: string;
								} | null;
							}>;
					  };
				primaryAffiliationSearch:
					| { __typename?: 'BadRequest' }
					| {
							__typename?: 'HCOAffiliationsResults';
							results: Array<{
								__typename?: 'ParentHCO';
								vid_V: string;
								classOfWork_V?: string | null;
								isPrimaryRelationship_V?: boolean | null;
								parentHcoStatus_VId?: string | null;
								childVeevaid_V?: string | null;
								parentVeevaid_V?: string | null;
								jobTitle_V?: string | null;
								parentHco:
									| {
											__typename?: 'HCO';
											officePhoneCda_V?: string | null;
											vid_V: string;
											veevaid_V: string;
											statusCda_V?: string | null;
											statusCda_VId?: string | null;
											hcoNameCda_V?: string | null;
											hcoNameShort_V?: string | null;
											hcoNameEnglish_V?: string | null;
											hcoNameIntl_V?: string | null;
											hcoTypeCda_V?: string | null;
											addresses: Array<{
												__typename?: 'Address';
												streetAddress1Cda_V?: string | null;
												streetAddress1Intl_V?: string | null;
												streetAddress2Cda_V?: string | null;
												streetAddress2Intl_V?: string | null;
												postalCodeCda_V?: string | null;
												postalCodeIntl_V?: string | null;
												postalCodeFullUs_V?: string | null;
												cbsa_V?: string | null;
												latitudeCda_V?: number | null;
												longitudeCda_V?: number | null;
												statusCda_V?: string | null;
												statusCda_VId?: string | null;
												subStateAdminUnit_V?: string | null;
												businessCda_V?: boolean | null;
												dpvConfirmedIndicator_V?: string | null;
												buildingIdentifier_V?: string | null;
												phoneCda_V?: string | null;
												faxCda_V?: string | null;
												vid_V: string;
												primaryCda_V?: boolean | null;
												cityCda_V?: string | null;
												cityIntl_V?: string | null;
												stateCda_V?: string | null;
												countryCda_V?: string | null;
												hospitalCampus?:
													| {
															__typename?: 'HCO';
															vid_V: string;
															veevaid_V: string;
															statusCda_V?: string | null;
															statusCda_VId?: string | null;
															hcoNameCda_V?: string | null;
															hcoNameShort_V?: string | null;
															hcoNameEnglish_V?: string | null;
															hcoNameIntl_V?: string | null;
															hcoTypeCda_V?: string | null;
															addresses: Array<{
																__typename?: 'Address';
																vid_V: string;
																primaryCda_V?: boolean | null;
																cityCda_V?: string | null;
																cityIntl_V?: string | null;
																stateCda_V?: string | null;
																countryCda_V?: string | null;
																streetAddress1Cda_V?: string | null;
																streetAddress1Intl_V?: string | null;
																postalCodeCda_V?: string | null;
																postalCodeIntl_V?: string | null;
															}>;
															hcoType?: {
																__typename?: 'HCOType';
																id: string;
																name: string;
															} | null;
													  }
													| { __typename?: 'ResourceNotFound'; message: string }
													| null;
											}>;
											hcoType?: {
												__typename?: 'HCOType';
												id: string;
												name: string;
											} | null;
									  }
									| { __typename?: 'ResourceNotFound'; message: string };
								relationshipType?: {
									__typename?: 'RelationshipType';
									code: string;
									name: string;
								} | null;
							}>;
					  };
				childAffiliationSearch:
					| { __typename: 'BadRequest' }
					| {
							__typename: 'HCOAffiliationsResults';
							inactiveCount: number;
							paginationMetadata: {
								__typename?: 'PaginationMetadata';
								total: number;
								page: number;
								pageSize: number;
								totalPages: number;
							};
							results: Array<{
								__typename?: 'ParentHCO';
								vid_V: string;
								classOfWork_V?: string | null;
								isPrimaryRelationship_V?: boolean | null;
								parentHcoStatus_VId?: string | null;
								childVeevaid_V?: string | null;
								parentVeevaid_V?: string | null;
								jobTitle_V?: string | null;
								relationshipType?: {
									__typename?: 'RelationshipType';
									code: string;
									name: string;
								} | null;
								parentHco:
									| {
											__typename?: 'HCO';
											officePhoneCda_V?: string | null;
											vid_V: string;
											veevaid_V: string;
											statusCda_V?: string | null;
											statusCda_VId?: string | null;
											hcoNameCda_V?: string | null;
											hcoNameShort_V?: string | null;
											hcoNameEnglish_V?: string | null;
											hcoNameIntl_V?: string | null;
											hcoTypeCda_V?: string | null;
											addresses: Array<{
												__typename?: 'Address';
												streetAddress1Cda_V?: string | null;
												streetAddress1Intl_V?: string | null;
												streetAddress2Cda_V?: string | null;
												streetAddress2Intl_V?: string | null;
												postalCodeCda_V?: string | null;
												postalCodeIntl_V?: string | null;
												postalCodeFullUs_V?: string | null;
												cbsa_V?: string | null;
												latitudeCda_V?: number | null;
												longitudeCda_V?: number | null;
												statusCda_V?: string | null;
												statusCda_VId?: string | null;
												subStateAdminUnit_V?: string | null;
												businessCda_V?: boolean | null;
												dpvConfirmedIndicator_V?: string | null;
												buildingIdentifier_V?: string | null;
												phoneCda_V?: string | null;
												faxCda_V?: string | null;
												vid_V: string;
												primaryCda_V?: boolean | null;
												cityCda_V?: string | null;
												cityIntl_V?: string | null;
												stateCda_V?: string | null;
												countryCda_V?: string | null;
												hospitalCampus?:
													| {
															__typename?: 'HCO';
															vid_V: string;
															veevaid_V: string;
															statusCda_V?: string | null;
															statusCda_VId?: string | null;
															hcoNameCda_V?: string | null;
															hcoNameShort_V?: string | null;
															hcoNameEnglish_V?: string | null;
															hcoNameIntl_V?: string | null;
															hcoTypeCda_V?: string | null;
															addresses: Array<{
																__typename?: 'Address';
																vid_V: string;
																primaryCda_V?: boolean | null;
																cityCda_V?: string | null;
																cityIntl_V?: string | null;
																stateCda_V?: string | null;
																countryCda_V?: string | null;
																streetAddress1Cda_V?: string | null;
																streetAddress1Intl_V?: string | null;
																postalCodeCda_V?: string | null;
																postalCodeIntl_V?: string | null;
															}>;
															hcoType?: {
																__typename?: 'HCOType';
																id: string;
																name: string;
															} | null;
													  }
													| { __typename?: 'ResourceNotFound'; message: string }
													| null;
											}>;
											hcoType?: {
												__typename?: 'HCOType';
												id: string;
												name: string;
											} | null;
									  }
									| { __typename?: 'ResourceNotFound'; message: string };
								childHco:
									| {
											__typename?: 'HCO';
											officePhoneCda_V?: string | null;
											vid_V: string;
											veevaid_V: string;
											statusCda_V?: string | null;
											statusCda_VId?: string | null;
											hcoNameCda_V?: string | null;
											hcoNameShort_V?: string | null;
											hcoNameEnglish_V?: string | null;
											hcoNameIntl_V?: string | null;
											hcoTypeCda_V?: string | null;
											addresses: Array<{
												__typename?: 'Address';
												streetAddress1Cda_V?: string | null;
												streetAddress1Intl_V?: string | null;
												streetAddress2Cda_V?: string | null;
												streetAddress2Intl_V?: string | null;
												postalCodeCda_V?: string | null;
												postalCodeIntl_V?: string | null;
												postalCodeFullUs_V?: string | null;
												cbsa_V?: string | null;
												latitudeCda_V?: number | null;
												longitudeCda_V?: number | null;
												statusCda_V?: string | null;
												statusCda_VId?: string | null;
												subStateAdminUnit_V?: string | null;
												businessCda_V?: boolean | null;
												dpvConfirmedIndicator_V?: string | null;
												buildingIdentifier_V?: string | null;
												phoneCda_V?: string | null;
												faxCda_V?: string | null;
												vid_V: string;
												primaryCda_V?: boolean | null;
												cityCda_V?: string | null;
												cityIntl_V?: string | null;
												stateCda_V?: string | null;
												countryCda_V?: string | null;
												hospitalCampus?:
													| {
															__typename?: 'HCO';
															vid_V: string;
															veevaid_V: string;
															statusCda_V?: string | null;
															statusCda_VId?: string | null;
															hcoNameCda_V?: string | null;
															hcoNameShort_V?: string | null;
															hcoNameEnglish_V?: string | null;
															hcoNameIntl_V?: string | null;
															hcoTypeCda_V?: string | null;
															addresses: Array<{
																__typename?: 'Address';
																vid_V: string;
																primaryCda_V?: boolean | null;
																cityCda_V?: string | null;
																cityIntl_V?: string | null;
																stateCda_V?: string | null;
																countryCda_V?: string | null;
																streetAddress1Cda_V?: string | null;
																streetAddress1Intl_V?: string | null;
																postalCodeCda_V?: string | null;
																postalCodeIntl_V?: string | null;
															}>;
															hcoType?: {
																__typename?: 'HCOType';
																id: string;
																name: string;
															} | null;
													  }
													| { __typename?: 'ResourceNotFound'; message: string }
													| null;
											}>;
											hcoType?: {
												__typename?: 'HCOType';
												id: string;
												name: string;
											} | null;
									  }
									| { __typename?: 'ResourceNotFound'; message: string };
							}>;
					  };
				partnersAffiliationSearch:
					| { __typename?: 'BadRequest' }
					| {
							__typename?: 'HCOAffiliationsResults';
							inactiveCount: number;
							paginationMetadata: {
								__typename?: 'PaginationMetadata';
								total: number;
								page: number;
								pageSize: number;
								totalPages: number;
							};
							results: Array<{
								__typename?: 'ParentHCO';
								vid_V: string;
								classOfWork_V?: string | null;
								isPrimaryRelationship_V?: boolean | null;
								parentHcoStatus_VId?: string | null;
								childVeevaid_V?: string | null;
								parentVeevaid_V?: string | null;
								jobTitle_V?: string | null;
								relationshipType?: {
									__typename?: 'RelationshipType';
									code: string;
									name: string;
								} | null;
								parentHco:
									| {
											__typename?: 'HCO';
											officePhoneCda_V?: string | null;
											vid_V: string;
											veevaid_V: string;
											statusCda_V?: string | null;
											statusCda_VId?: string | null;
											hcoNameCda_V?: string | null;
											hcoNameShort_V?: string | null;
											hcoNameEnglish_V?: string | null;
											hcoNameIntl_V?: string | null;
											hcoTypeCda_V?: string | null;
											addresses: Array<{
												__typename?: 'Address';
												streetAddress1Cda_V?: string | null;
												streetAddress1Intl_V?: string | null;
												streetAddress2Cda_V?: string | null;
												streetAddress2Intl_V?: string | null;
												postalCodeCda_V?: string | null;
												postalCodeIntl_V?: string | null;
												postalCodeFullUs_V?: string | null;
												cbsa_V?: string | null;
												latitudeCda_V?: number | null;
												longitudeCda_V?: number | null;
												statusCda_V?: string | null;
												statusCda_VId?: string | null;
												subStateAdminUnit_V?: string | null;
												businessCda_V?: boolean | null;
												dpvConfirmedIndicator_V?: string | null;
												buildingIdentifier_V?: string | null;
												phoneCda_V?: string | null;
												faxCda_V?: string | null;
												vid_V: string;
												primaryCda_V?: boolean | null;
												cityCda_V?: string | null;
												cityIntl_V?: string | null;
												stateCda_V?: string | null;
												countryCda_V?: string | null;
												hospitalCampus?:
													| {
															__typename?: 'HCO';
															vid_V: string;
															veevaid_V: string;
															statusCda_V?: string | null;
															statusCda_VId?: string | null;
															hcoNameCda_V?: string | null;
															hcoNameShort_V?: string | null;
															hcoNameEnglish_V?: string | null;
															hcoNameIntl_V?: string | null;
															hcoTypeCda_V?: string | null;
															addresses: Array<{
																__typename?: 'Address';
																vid_V: string;
																primaryCda_V?: boolean | null;
																cityCda_V?: string | null;
																cityIntl_V?: string | null;
																stateCda_V?: string | null;
																countryCda_V?: string | null;
																streetAddress1Cda_V?: string | null;
																streetAddress1Intl_V?: string | null;
																postalCodeCda_V?: string | null;
																postalCodeIntl_V?: string | null;
															}>;
															hcoType?: {
																__typename?: 'HCOType';
																id: string;
																name: string;
															} | null;
													  }
													| { __typename?: 'ResourceNotFound'; message: string }
													| null;
											}>;
											hcoType?: {
												__typename?: 'HCOType';
												id: string;
												name: string;
											} | null;
									  }
									| { __typename?: 'ResourceNotFound'; message: string };
								childHco:
									| {
											__typename?: 'HCO';
											officePhoneCda_V?: string | null;
											vid_V: string;
											veevaid_V: string;
											statusCda_V?: string | null;
											statusCda_VId?: string | null;
											hcoNameCda_V?: string | null;
											hcoNameShort_V?: string | null;
											hcoNameEnglish_V?: string | null;
											hcoNameIntl_V?: string | null;
											hcoTypeCda_V?: string | null;
											addresses: Array<{
												__typename?: 'Address';
												streetAddress1Cda_V?: string | null;
												streetAddress1Intl_V?: string | null;
												streetAddress2Cda_V?: string | null;
												streetAddress2Intl_V?: string | null;
												postalCodeCda_V?: string | null;
												postalCodeIntl_V?: string | null;
												postalCodeFullUs_V?: string | null;
												cbsa_V?: string | null;
												latitudeCda_V?: number | null;
												longitudeCda_V?: number | null;
												statusCda_V?: string | null;
												statusCda_VId?: string | null;
												subStateAdminUnit_V?: string | null;
												businessCda_V?: boolean | null;
												dpvConfirmedIndicator_V?: string | null;
												buildingIdentifier_V?: string | null;
												phoneCda_V?: string | null;
												faxCda_V?: string | null;
												vid_V: string;
												primaryCda_V?: boolean | null;
												cityCda_V?: string | null;
												cityIntl_V?: string | null;
												stateCda_V?: string | null;
												countryCda_V?: string | null;
												hospitalCampus?:
													| {
															__typename?: 'HCO';
															vid_V: string;
															veevaid_V: string;
															statusCda_V?: string | null;
															statusCda_VId?: string | null;
															hcoNameCda_V?: string | null;
															hcoNameShort_V?: string | null;
															hcoNameEnglish_V?: string | null;
															hcoNameIntl_V?: string | null;
															hcoTypeCda_V?: string | null;
															addresses: Array<{
																__typename?: 'Address';
																vid_V: string;
																primaryCda_V?: boolean | null;
																cityCda_V?: string | null;
																cityIntl_V?: string | null;
																stateCda_V?: string | null;
																countryCda_V?: string | null;
																streetAddress1Cda_V?: string | null;
																streetAddress1Intl_V?: string | null;
																postalCodeCda_V?: string | null;
																postalCodeIntl_V?: string | null;
															}>;
															hcoType?: {
																__typename?: 'HCOType';
																id: string;
																name: string;
															} | null;
													  }
													| { __typename?: 'ResourceNotFound'; message: string }
													| null;
											}>;
											hcoType?: {
												__typename?: 'HCOType';
												id: string;
												name: string;
											} | null;
									  }
									| { __typename?: 'ResourceNotFound'; message: string };
							}>;
					  };
				dcrPartnersAffiliationSearch?:
					| { __typename?: 'BadRequest' }
					| {
							__typename?: 'HCOAffiliationsResults';
							inactiveCount: number;
							paginationMetadata: {
								__typename?: 'PaginationMetadata';
								total: number;
								page: number;
								pageSize: number;
								totalPages: number;
							};
							results: Array<{
								__typename?: 'ParentHCO';
								vid_V: string;
								classOfWork_V?: string | null;
								isPrimaryRelationship_V?: boolean | null;
								parentHcoStatus_VId?: string | null;
								childVeevaid_V?: string | null;
								parentVeevaid_V?: string | null;
								jobTitle_V?: string | null;
								parentHco:
									| {
											__typename?: 'HCO';
											officePhoneCda_V?: string | null;
											vid_V: string;
											veevaid_V: string;
											statusCda_V?: string | null;
											statusCda_VId?: string | null;
											hcoNameCda_V?: string | null;
											hcoNameShort_V?: string | null;
											hcoNameEnglish_V?: string | null;
											hcoNameIntl_V?: string | null;
											hcoTypeCda_V?: string | null;
											addresses: Array<{
												__typename?: 'Address';
												streetAddress1Cda_V?: string | null;
												streetAddress1Intl_V?: string | null;
												streetAddress2Cda_V?: string | null;
												streetAddress2Intl_V?: string | null;
												postalCodeCda_V?: string | null;
												postalCodeIntl_V?: string | null;
												postalCodeFullUs_V?: string | null;
												cbsa_V?: string | null;
												latitudeCda_V?: number | null;
												longitudeCda_V?: number | null;
												statusCda_V?: string | null;
												statusCda_VId?: string | null;
												subStateAdminUnit_V?: string | null;
												businessCda_V?: boolean | null;
												dpvConfirmedIndicator_V?: string | null;
												buildingIdentifier_V?: string | null;
												phoneCda_V?: string | null;
												faxCda_V?: string | null;
												vid_V: string;
												primaryCda_V?: boolean | null;
												cityCda_V?: string | null;
												cityIntl_V?: string | null;
												stateCda_V?: string | null;
												countryCda_V?: string | null;
												hospitalCampus?:
													| {
															__typename?: 'HCO';
															vid_V: string;
															veevaid_V: string;
															statusCda_V?: string | null;
															statusCda_VId?: string | null;
															hcoNameCda_V?: string | null;
															hcoNameShort_V?: string | null;
															hcoNameEnglish_V?: string | null;
															hcoNameIntl_V?: string | null;
															hcoTypeCda_V?: string | null;
															addresses: Array<{
																__typename?: 'Address';
																vid_V: string;
																primaryCda_V?: boolean | null;
																cityCda_V?: string | null;
																cityIntl_V?: string | null;
																stateCda_V?: string | null;
																countryCda_V?: string | null;
																streetAddress1Cda_V?: string | null;
																streetAddress1Intl_V?: string | null;
																postalCodeCda_V?: string | null;
																postalCodeIntl_V?: string | null;
															}>;
															hcoType?: {
																__typename?: 'HCOType';
																id: string;
																name: string;
															} | null;
													  }
													| { __typename?: 'ResourceNotFound'; message: string }
													| null;
											}>;
											hcoType?: {
												__typename?: 'HCOType';
												id: string;
												name: string;
											} | null;
									  }
									| { __typename?: 'ResourceNotFound'; message: string };
								relationshipType?: {
									__typename?: 'RelationshipType';
									code: string;
									name: string;
								} | null;
							}>;
					  };
				affiliatedHcpSearch:
					| { __typename?: 'BadRequest' }
					| {
							__typename?: 'HCOAffiliatedHcpsResults';
							inactiveCount: number;
							paginationMetadata: {
								__typename?: 'PaginationMetadata';
								total: number;
								page: number;
								pageSize: number;
								totalPages: number;
							};
							results: Array<{
								__typename?: 'HCP';
								vid_V: string;
								veevaid_V: string;
								statusCda_V?: string | null;
								statusCda_VId?: string | null;
								firstNameCda_V?: string | null;
								firstNameIntl_V?: string | null;
								middleNameCda_V?: string | null;
								middleNameIntl_V?: string | null;
								lastNameCda_V?: string | null;
								lastNameIntl_V?: string | null;
								nickname_V?: string | null;
								prefixCda_V?: string | null;
								suffixCda_V?: string | null;
								allDegreeCda_V?: string | null;
								degree1Cda_V?: string | null;
								hcpTypeCda_V?: string | null;
								affiliationInHco?: {
									__typename?: 'ParentHCO';
									vid_V: string;
									classOfWork_V?: string | null;
									isPrimaryRelationship_V?: boolean | null;
									parentHcoStatus_VId?: string | null;
									childVeevaid_V?: string | null;
									parentVeevaid_V?: string | null;
									jobTitle_V?: string | null;
									parentHco:
										| {
												__typename?: 'HCO';
												officePhoneCda_V?: string | null;
												vid_V: string;
												veevaid_V: string;
												statusCda_V?: string | null;
												statusCda_VId?: string | null;
												hcoNameCda_V?: string | null;
												hcoNameShort_V?: string | null;
												hcoNameEnglish_V?: string | null;
												hcoNameIntl_V?: string | null;
												hcoTypeCda_V?: string | null;
												addresses: Array<{
													__typename?: 'Address';
													streetAddress1Cda_V?: string | null;
													streetAddress1Intl_V?: string | null;
													streetAddress2Cda_V?: string | null;
													streetAddress2Intl_V?: string | null;
													postalCodeCda_V?: string | null;
													postalCodeIntl_V?: string | null;
													postalCodeFullUs_V?: string | null;
													cbsa_V?: string | null;
													latitudeCda_V?: number | null;
													longitudeCda_V?: number | null;
													statusCda_V?: string | null;
													statusCda_VId?: string | null;
													subStateAdminUnit_V?: string | null;
													businessCda_V?: boolean | null;
													dpvConfirmedIndicator_V?: string | null;
													buildingIdentifier_V?: string | null;
													phoneCda_V?: string | null;
													faxCda_V?: string | null;
													vid_V: string;
													primaryCda_V?: boolean | null;
													cityCda_V?: string | null;
													cityIntl_V?: string | null;
													stateCda_V?: string | null;
													countryCda_V?: string | null;
													hospitalCampus?:
														| {
																__typename?: 'HCO';
																vid_V: string;
																veevaid_V: string;
																statusCda_V?: string | null;
																statusCda_VId?: string | null;
																hcoNameCda_V?: string | null;
																hcoNameShort_V?: string | null;
																hcoNameEnglish_V?: string | null;
																hcoNameIntl_V?: string | null;
																hcoTypeCda_V?: string | null;
																addresses: Array<{
																	__typename?: 'Address';
																	vid_V: string;
																	primaryCda_V?: boolean | null;
																	cityCda_V?: string | null;
																	cityIntl_V?: string | null;
																	stateCda_V?: string | null;
																	countryCda_V?: string | null;
																	streetAddress1Cda_V?: string | null;
																	streetAddress1Intl_V?: string | null;
																	postalCodeCda_V?: string | null;
																	postalCodeIntl_V?: string | null;
																}>;
																hcoType?: {
																	__typename?: 'HCOType';
																	id: string;
																	name: string;
																} | null;
														  }
														| {
																__typename?: 'ResourceNotFound';
																message: string;
														  }
														| null;
												}>;
												hcoType?: {
													__typename?: 'HCOType';
													id: string;
													name: string;
												} | null;
										  }
										| { __typename?: 'ResourceNotFound'; message: string };
									relationshipType?: {
										__typename?: 'RelationshipType';
										code: string;
										name: string;
									} | null;
								} | null;
								addresses: Array<{
									__typename?: 'Address';
									streetAddress1Cda_V?: string | null;
									streetAddress1Intl_V?: string | null;
									streetAddress2Cda_V?: string | null;
									streetAddress2Intl_V?: string | null;
									postalCodeCda_V?: string | null;
									postalCodeIntl_V?: string | null;
									postalCodeFullUs_V?: string | null;
									cbsa_V?: string | null;
									latitudeCda_V?: number | null;
									longitudeCda_V?: number | null;
									statusCda_V?: string | null;
									statusCda_VId?: string | null;
									subStateAdminUnit_V?: string | null;
									businessCda_V?: boolean | null;
									dpvConfirmedIndicator_V?: string | null;
									buildingIdentifier_V?: string | null;
									phoneCda_V?: string | null;
									faxCda_V?: string | null;
									vid_V: string;
									primaryCda_V?: boolean | null;
									cityCda_V?: string | null;
									cityIntl_V?: string | null;
									stateCda_V?: string | null;
									countryCda_V?: string | null;
									hospitalCampus?:
										| {
												__typename?: 'HCO';
												vid_V: string;
												veevaid_V: string;
												statusCda_V?: string | null;
												statusCda_VId?: string | null;
												hcoNameCda_V?: string | null;
												hcoNameShort_V?: string | null;
												hcoNameEnglish_V?: string | null;
												hcoNameIntl_V?: string | null;
												hcoTypeCda_V?: string | null;
												addresses: Array<{
													__typename?: 'Address';
													vid_V: string;
													primaryCda_V?: boolean | null;
													cityCda_V?: string | null;
													cityIntl_V?: string | null;
													stateCda_V?: string | null;
													countryCda_V?: string | null;
													streetAddress1Cda_V?: string | null;
													streetAddress1Intl_V?: string | null;
													postalCodeCda_V?: string | null;
													postalCodeIntl_V?: string | null;
												}>;
												hcoType?: {
													__typename?: 'HCOType';
													id: string;
													name: string;
												} | null;
										  }
										| { __typename?: 'ResourceNotFound'; message: string }
										| null;
								}>;
								hcpType?: {
									__typename?: 'HCPType';
									id: string;
									name: string;
									count: number;
								} | null;
								hcpSpecialties: Array<{
									__typename?: 'HCPSpecialty';
									primary: boolean;
									specialty: {
										__typename?: 'Specialty';
										id: string;
										name: string;
										specialtyGroup: {
											__typename?: 'SpecialtyGroup';
											id: string;
											name: string;
										};
									};
								}>;
								affiliationSearch:
									| { __typename?: 'BadRequest' }
									| {
											__typename?: 'HCPAffiliationsResults';
											results: Array<{
												__typename?: 'ParentHCO';
												vid_V: string;
												classOfWork_V?: string | null;
												isPrimaryRelationship_V?: boolean | null;
												parentHcoStatus_VId?: string | null;
												childVeevaid_V?: string | null;
												parentVeevaid_V?: string | null;
												jobTitle_V?: string | null;
												parentHco:
													| {
															__typename?: 'HCO';
															officePhoneCda_V?: string | null;
															vid_V: string;
															veevaid_V: string;
															statusCda_V?: string | null;
															statusCda_VId?: string | null;
															hcoNameCda_V?: string | null;
															hcoNameShort_V?: string | null;
															hcoNameEnglish_V?: string | null;
															hcoNameIntl_V?: string | null;
															hcoTypeCda_V?: string | null;
															addresses: Array<{
																__typename?: 'Address';
																streetAddress1Cda_V?: string | null;
																streetAddress1Intl_V?: string | null;
																streetAddress2Cda_V?: string | null;
																streetAddress2Intl_V?: string | null;
																postalCodeCda_V?: string | null;
																postalCodeIntl_V?: string | null;
																postalCodeFullUs_V?: string | null;
																cbsa_V?: string | null;
																latitudeCda_V?: number | null;
																longitudeCda_V?: number | null;
																statusCda_V?: string | null;
																statusCda_VId?: string | null;
																subStateAdminUnit_V?: string | null;
																businessCda_V?: boolean | null;
																dpvConfirmedIndicator_V?: string | null;
																buildingIdentifier_V?: string | null;
																phoneCda_V?: string | null;
																faxCda_V?: string | null;
																vid_V: string;
																primaryCda_V?: boolean | null;
																cityCda_V?: string | null;
																cityIntl_V?: string | null;
																stateCda_V?: string | null;
																countryCda_V?: string | null;
																hospitalCampus?:
																	| {
																			__typename?: 'HCO';
																			vid_V: string;
																			veevaid_V: string;
																			statusCda_V?: string | null;
																			statusCda_VId?: string | null;
																			hcoNameCda_V?: string | null;
																			hcoNameShort_V?: string | null;
																			hcoNameEnglish_V?: string | null;
																			hcoNameIntl_V?: string | null;
																			hcoTypeCda_V?: string | null;
																			addresses: Array<{
																				__typename?: 'Address';
																				vid_V: string;
																				primaryCda_V?: boolean | null;
																				cityCda_V?: string | null;
																				cityIntl_V?: string | null;
																				stateCda_V?: string | null;
																				countryCda_V?: string | null;
																				streetAddress1Cda_V?: string | null;
																				streetAddress1Intl_V?: string | null;
																				postalCodeCda_V?: string | null;
																				postalCodeIntl_V?: string | null;
																			}>;
																			hcoType?: {
																				__typename?: 'HCOType';
																				id: string;
																				name: string;
																			} | null;
																	  }
																	| {
																			__typename?: 'ResourceNotFound';
																			message: string;
																	  }
																	| null;
															}>;
															hcoType?: {
																__typename?: 'HCOType';
																id: string;
																name: string;
															} | null;
													  }
													| {
															__typename?: 'ResourceNotFound';
															message: string;
													  };
												relationshipType?: {
													__typename?: 'RelationshipType';
													code: string;
													name: string;
												} | null;
											}>;
									  };
							}>;
					  };
				addresses: Array<{
					__typename?: 'Address';
					streetAddress1Cda_V?: string | null;
					streetAddress1Intl_V?: string | null;
					streetAddress2Cda_V?: string | null;
					streetAddress2Intl_V?: string | null;
					postalCodeCda_V?: string | null;
					postalCodeIntl_V?: string | null;
					postalCodeFullUs_V?: string | null;
					cbsa_V?: string | null;
					latitudeCda_V?: number | null;
					longitudeCda_V?: number | null;
					statusCda_V?: string | null;
					statusCda_VId?: string | null;
					subStateAdminUnit_V?: string | null;
					businessCda_V?: boolean | null;
					dpvConfirmedIndicator_V?: string | null;
					buildingIdentifier_V?: string | null;
					phoneCda_V?: string | null;
					faxCda_V?: string | null;
					vid_V: string;
					primaryCda_V?: boolean | null;
					cityCda_V?: string | null;
					cityIntl_V?: string | null;
					stateCda_V?: string | null;
					countryCda_V?: string | null;
					hospitalCampus?:
						| {
								__typename?: 'HCO';
								vid_V: string;
								veevaid_V: string;
								statusCda_V?: string | null;
								statusCda_VId?: string | null;
								hcoNameCda_V?: string | null;
								hcoNameShort_V?: string | null;
								hcoNameEnglish_V?: string | null;
								hcoNameIntl_V?: string | null;
								hcoTypeCda_V?: string | null;
								addresses: Array<{
									__typename?: 'Address';
									vid_V: string;
									primaryCda_V?: boolean | null;
									cityCda_V?: string | null;
									cityIntl_V?: string | null;
									stateCda_V?: string | null;
									countryCda_V?: string | null;
									streetAddress1Cda_V?: string | null;
									streetAddress1Intl_V?: string | null;
									postalCodeCda_V?: string | null;
									postalCodeIntl_V?: string | null;
								}>;
								hcoType?: {
									__typename?: 'HCOType';
									id: string;
									name: string;
								} | null;
						  }
						| { __typename?: 'ResourceNotFound'; message: string }
						| null;
				}>;
				licenses: Array<{
					__typename?: 'License';
					vid_V: string;
					typeValue_VId?: string | null;
					bestStateLicense_V?: boolean | null;
					body_V?: string | null;
					collabAgreeRequired_V?: string | null;
					comprehensivePrescriptiveAuthority_V?: string | null;
					comprehensiveSampleEligibility_V?: string | null;
					ctrlSubstancePrescriptive_V?: string | null;
					ctrlSubstanceSample_V?: string | null;
					deaBusinessActivityCode_V?: string | null;
					deaPaymentIndicator_V?: string | null;
					drugSchedule_V?: string | null;
					expirationDate_V?: any | null;
					gracePeriod_V?: any | null;
					licenseCertification_V?: string | null;
					licenseDegree_V?: string | null;
					licenseEligibility_V?: string | null;
					licenseNumber_V?: string | null;
					licenseStatusCondition_V?: string | null;
					licenseStatus_V?: string | null;
					licenseSubtype_V?: string | null;
					rxaEligible_V?: string | null;
					sourceAddress_V?: string | null;
					type_V?: string | null;
					address?: {
						__typename?: 'Address';
						streetAddress1Cda_V?: string | null;
						streetAddress1Intl_V?: string | null;
						streetAddress2Cda_V?: string | null;
						streetAddress2Intl_V?: string | null;
						postalCodeCda_V?: string | null;
						postalCodeIntl_V?: string | null;
						postalCodeFullUs_V?: string | null;
						cbsa_V?: string | null;
						latitudeCda_V?: number | null;
						longitudeCda_V?: number | null;
						statusCda_V?: string | null;
						statusCda_VId?: string | null;
						subStateAdminUnit_V?: string | null;
						businessCda_V?: boolean | null;
						dpvConfirmedIndicator_V?: string | null;
						buildingIdentifier_V?: string | null;
						phoneCda_V?: string | null;
						faxCda_V?: string | null;
						vid_V: string;
						primaryCda_V?: boolean | null;
						cityCda_V?: string | null;
						cityIntl_V?: string | null;
						stateCda_V?: string | null;
						countryCda_V?: string | null;
						hospitalCampus?:
							| {
									__typename?: 'HCO';
									vid_V: string;
									veevaid_V: string;
									statusCda_V?: string | null;
									statusCda_VId?: string | null;
									hcoNameCda_V?: string | null;
									hcoNameShort_V?: string | null;
									hcoNameEnglish_V?: string | null;
									hcoNameIntl_V?: string | null;
									hcoTypeCda_V?: string | null;
									addresses: Array<{
										__typename?: 'Address';
										vid_V: string;
										primaryCda_V?: boolean | null;
										cityCda_V?: string | null;
										cityIntl_V?: string | null;
										stateCda_V?: string | null;
										countryCda_V?: string | null;
										streetAddress1Cda_V?: string | null;
										streetAddress1Intl_V?: string | null;
										postalCodeCda_V?: string | null;
										postalCodeIntl_V?: string | null;
									}>;
									hcoType?: {
										__typename?: 'HCOType';
										id: string;
										name: string;
									} | null;
							  }
							| { __typename?: 'ResourceNotFound'; message: string }
							| null;
					} | null;
				}>;
				hcoType?: { __typename?: 'HCOType'; id: string; name: string } | null;
		  }
		| { __typename?: 'ResourceNotFound'; message: string };
};

export const GetHcoByIdDocument = gql`
	query GetHCOById(
		$vid: ID!
		$affiliationsPageSize: Int!
		$includeInactiveAffiliation: Boolean! = false
		$includeDcrPartners: Boolean! = false
	) {
		hco(payload: { vid: $vid }) {
			...HCO
			...NotFoundError
		}
	}
	${HcoFragmentDoc}
	${NotFoundErrorFragmentDoc}
`;

/**
 * __useGetHcoByIdQuery__
 *
 * To run a query within a React component, call `useGetHcoByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHcoByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHcoByIdQuery({
 *   variables: {
 *      vid: // value for 'vid'
 *      affiliationsPageSize: // value for 'affiliationsPageSize'
 *      includeInactiveAffiliation: // value for 'includeInactiveAffiliation'
 *      includeDcrPartners: // value for 'includeDcrPartners'
 *   },
 * });
 */
export function useGetHcoByIdQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetHcoByIdQuery,
		GetHcoByIdQueryVariables
	> &
		(
			| { variables: GetHcoByIdQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetHcoByIdQuery, GetHcoByIdQueryVariables>(
		GetHcoByIdDocument,
		options
	);
}
export function useGetHcoByIdLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetHcoByIdQuery,
		GetHcoByIdQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetHcoByIdQuery, GetHcoByIdQueryVariables>(
		GetHcoByIdDocument,
		options
	);
}
export function useGetHcoByIdSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetHcoByIdQuery, GetHcoByIdQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetHcoByIdQuery, GetHcoByIdQueryVariables>(
		GetHcoByIdDocument,
		options
	);
}
export type GetHcoByIdQueryHookResult = ReturnType<typeof useGetHcoByIdQuery>;
export type GetHcoByIdLazyQueryHookResult = ReturnType<
	typeof useGetHcoByIdLazyQuery
>;
export type GetHcoByIdSuspenseQueryHookResult = ReturnType<
	typeof useGetHcoByIdSuspenseQuery
>;
export type GetHcoByIdQueryResult = Apollo.QueryResult<
	GetHcoByIdQuery,
	GetHcoByIdQueryVariables
>;
